import React from 'react'
import { Link } from 'react-router-dom'
import { FaFacebook, FaInstagram, FaYoutube, FaLocationArrow } from "react-icons/fa";

function Footer() {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // Optional: Adds smooth scrolling
        });
    };
    return (
        <>
            {/* Footer Start */}
            <div className="container-fluid footer bg-dark text-white-50  py-4 px-4 px-lg-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="row">

                    <div className='col-xl-4'>
                        <a href="index.html" className="navbar-brand">
                            <h1 className="display-5 text-primary">Maa And Me Portraits</h1>
                        </a>
                        <p>Welcome to Maa And Me Portraits, where moments come alive through the lens of creativity. We specialize in capturing the essence of life’s cherished memories.</p>
                    </div>


                    <div className="col-xl-4 flex-column pt-1 justify-content-center ">
                        <div className='mx-auto'>
                            <h4 className="text-light mb-3">Quick Links</h4>

                            <Link to="/" className="btn btn-link" onClick={scrollToTop}>
                                Home
                            </Link>
                            <Link to="/about" className="btn btn-link" onClick={scrollToTop}>
                                About Us
                            </Link>
                            <Link to="/services" className="btn btn-link" onClick={scrollToTop}>
                                Our Services
                            </Link>
                            <Link to="/contact" className="btn btn-link" onClick={scrollToTop}>
                                Contact US
                            </Link>
                        </div>
                    </div>


                    <div className="col-xl-4 flex-column pt-4 justify-content-center ">
                        <h4 className="text-light mb-0">Vist US</h4>
                        <div className='col-xl-9 pt-3 flex-column justify-content-end align-items-start'>
                            <div >
                                <p><i className="fa fa-map-marker-alt me-2" />G-408, Sumel 11, Indian textile plaza, Namaste Circle, Shahibaug, Ahmedabad, Gujarat 380004</p>
                                <p><i className="fa fa-phone-alt me-2" />092651 97287</p>
                                <p><i className="fa fa-envelope me-2" />maa.me.portait@gmail.com</p>
                            </div>
                            <div className="d-flex flex-flex-column-reverse justify-content-start mt-4">
                                <a
                                    href="https://www.instagram.com/maaandmeportraits?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-square btn-outline-primary rounded-circle me-2"
                                >
                                    <FaInstagram className="w-6 h-6" />
                                </a>

                                <a
                                    href="https://www.facebook.com/profile.php?id=61550335285324"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-square btn-outline-primary rounded-circle me-2"
                                >
                                    <FaFacebook className="w-6 h-6" />
                                </a>

                                <a
                                    href="https://maps.app.goo.gl/uyTaWnkK9DGPLaqz6" 
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-square btn-outline-primary rounded-circle me-2"
                                >
                                    <FaLocationArrow className="w-6 h-6" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Footer bottom copyright */}
                <div className="mt-3 pt-2 border-top border-secondary">
                    <p className="text-sm text-white text-center mb-0">
                        © {new Date().getFullYear()},{" "}
                        <Link to="/" className="text-white fw-bold">
                            Maa And Me Portraits
                        </Link>{" "}
                        | Developed by{" "}
                        <a
                            href="https://www.ajtechsolution.com" // <-- change to your real link
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary fw-bold"
                        >
                            AJ Tech Solution
                        </a>
                    </p>
                </div>
            </div>
            {/* Footer End */}
        </>
    )
}

export default Footer
